import setSiteMeta from '../base-saving-actions/set-site-meta';

const createCurrentColorPaletteVersion = (version) =>
  setSiteMeta(['customization', 'currentColorPaletteVersion'], version);

export default createCurrentColorPaletteVersion;
